import { DocumentState } from "~/types/enums/DocumentState";

export const useSubmitEdittedRevision = async (
  documentId: string,
  revision?: Revision,
  hasChecklist: boolean = true
) => {
  if (!revision) {
    useBaseToast("Oops! Something went wrong.", "error");
    return false;
  }

  if (
    revision.fileObject == undefined &&
    (revision.fileObjects == undefined || revision.fileObjects.length == 0)
  ) {
    if (revision.studentSubmissionOps == undefined) {
      useBaseToast("No changes to submit", "error");
      return false;
    }

    await $fetch(`/api/${documentId}/${revision.id}/parse/quill`, {
      method: "POST",
      headers: await useApiHeaders(),
      body: {
        quill: revision.studentSubmissionOps,
      },
    });
  } else {
    // File previews do not go through the parser that submits written papers.
    await useDocuments().updateDocumentStateById(
      documentId,
      DocumentState.submitted
    );
  }

  return true;
};
